import { Grid, Dialog, DialogContent, DialogContentText, DialogTitle, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type UnsupportedBrowserDialogProps = {
  open: boolean;
  onClose?: () => void;
  isIos: boolean;
};

export const UnsupportedBrowserDialog = ({ open, onClose, isIos }: UnsupportedBrowserDialogProps) => {
  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby="unsupported-browser-dialog-title"
      aria-describedby="unsupported-browser-dialog-description"
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: 'relative',
          padding: 0,
          marginLeft: 'auto',
          paddingRight: '8px',
          paddingTop: '8px',
          color: theme.palette.grey[500]
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle
        id="unsupported-browser-dialog-title"
        className="font-bold"
        sx={{ fontSize: '16px', textAlign: 'center' }}
      >
        本人認証できません
      </DialogTitle>
      <DialogContent
        id="unsupported-browser-dialog-description"
        sx={{ textAlign: 'center', backgroundColor: '#FFF', paddingBottom: '32px' }}
      >
        <DialogContentText fontSize={'14px'} color={'#000'} sx={{ marginBottom: '24px' }}>
          LINEブラウザは
          <br />
          デジタル認証アプリに対応していません。
          <br />
          メディレコアプリをインストールするか、
          <br />
          別のブラウザをご利用ください。
        </DialogContentText>
        <div className="flex flex-row justify-center items-between gap-4">
          <Grid item>
            <div className="h-full flex flex-col justify-start items-center gap-2">
              <div className="flex justify-center items-center w-[52px] h-[52px] rounded-xl border border-2 border-gray">
                <img className="w-full h-full p-1" src="/logo512.png" alt="" />
              </div>
              <Typography className="font-bold" fontSize={13} whiteSpace={'nowrap'}>
                メディレコ
              </Typography>
            </div>
          </Grid>
          <Grid item>
            <div className="flex flex-col gap-1">
              {isIos === true ? (
                <a href="https://apps.apple.com/jp/app/id6738941254" target="_blank" rel="noopener noreferrer">
                  <img src="/images/mynumber/DownloadOnTheAppStore.svg" alt="" />
                </a>
              ) : (
                <a
                  href="https://play.google.com/store/apps/details?id=clinic.helthinterview.medireco&hl=ja"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/images/mynumber/GetItOnGooglePlay.svg" alt="" />
                </a>
              )}
            </div>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
};
